module.exports = __webpack_public_path__ + "img/lukoil-logo.9c7f4acc.png";